interface IResponse {
  code: number;
  message: string;
  ttl: number;
  // data: any;
}

/**
 * 房间信息接口: /web/live/room/info
 * http://bapi.bilibili.co/project/9754/interface/api/444018
 */
export interface IRoomInfoRequest {
  room_id: number; // 直播房间号
}

export interface IRoomInfoResponse extends IResponse {
  data: IRoomInfoResponseData
}

export interface IRoomInfoResponseData {
  room_id: number; // 直播间ID
  live_key: string;
  title: string; // 直播间标题
  primary: IPrimary;
  cover: string; // 直播间封面
  state: number; // 直播间状态 0:未开播 1:开播
  room_type: number; // 直播间类型 0:竖半屏 1:竖全屏
  tips: string; // 展示在直播间未开播时
  right: IRight;
  online: string; // 在线人数
  online_interval: number; // 在线人数请求间隔
  top_message: string; // 直播间介绍
  watermark: IWatermark
  block_info: {
    notice: string, // 屏蔽公告
    end_time: number, // 结束屏蔽时间
  }
  recharge_bar_info: IRechargeBarInfo;
}

interface IWatermark {
  height: number;
  width: number;
  text: string;
  image: string;
}

// 主播信息
interface IPrimary {
  mid: number; // 主播ID
  name: string; // 昵称
  face: string; // 头像
  attention: number; // 是否关注
  followers: string; // 粉丝数
}

// 直播间能力
interface IRight {
  no_dm: number; // 是否禁止弹幕 0:否 1:是
}

interface IRechargeBarInfo {
  name: string;
  level: number;
  icon: string;
  color: {
    content_color: string;
    gradient_color_start: string;
    gradient_color_end: string;
  }
  notice: {
    content: string;
    delay: number;
    duration: number;
  };
  target_url: string;
  current_point: number;
  min_point: number;
  max_point: number;
}

/**
 * 在线人数接口: /web/live/room/online
 * http://bapi.bilibili.co/project/9754/interface/api/444061
 */
export interface IRoomOnlineRequest {
  room_id: number; // 直播房间号
}

export interface IRoomOnlineResponse extends IResponse {
  data: IRoomOnlineResponseData
}

export interface IRoomOnlineResponseData {
  online: string; // 在线人数，字符串类型，已整合K/M数量级的逻辑
  online_interval: number; // 间隔指定的 X 秒后，重新请求本接口更新在线人数
}

/**
 * playurl接口: /web/live/playurl
 * http://bapi.bilibili.co/project/9754/interface/api/444060
 */
export interface IPlayUrlRequest {
  room_id: number; // 直播房间号
  qn?: number; // 需要播放的清晰度
  https_url_req?: boolean // 是否https
}

export interface IPlayUrlResponse extends IResponse {
  data: IPlayUrlResponseData;
}

export interface IPlayUrlResponseData {
  info: IPlayInfo[];
}

export interface IPlayInfo {
  qn: IQnItem[];
  protocol: string;
  format: string;
  codec: string;
  current_qn: number;
  url: string;
}

export interface IQnItem {
  qn: number;
  desc: string;
}

/**
 * 行为上报（关注，转发）: /web/live/comment/action_report
 * http://bapi.bilibili.co/project/9754/interface/api/444064
 */
export interface IActionReportRequest {
  type: number; // 动作类型：1.关注 2.转发
  room_id: number; // 房间号
}

export interface IActionReportResponse extends IResponse {

}

/**
 * 关注/取关用户: /intl/gateway/web/v2/user/follow/modify,
 * http://bapi.bilibili.co/project/5885/interface/api/404596
 */
export interface IFollowRequest {
  fid: number; // 关注的人 mid
  action: number; // 1加关 2取关
  h5_url: string; // 操作的来源页面
  spm_id?: string;
  from_spm_id?: string;
}

// 心跳上报参数
export interface IHeartbeatRequest {
  stime: number; // 上报时间戳
  quality: number; // 清晰度
  paused_time: number; // 播放器暂停总耗时
  played_time: number; // 播放器实际播放耗时
  spmid: string; // spmid
  s_locale: string; // 服务端地区
  timezone: string; // 时区
  from_spmid: string;  // from_spmid                          
  session: string; // 一次播放周期(进入直播间到退出都是同一个值，可以统计一次观看所有的心跳)

  // 直播新增
  business: string; // 资源类型，"ugc"，"ogv"，"live"
  room_id: number;  // 直播房间号
  ruid: number;    // 主播id
  live_key: string; // 直播场次
  action: HeartbeatAction; // 用户当前在直播间的状态状态 start continue，end
}

export enum HeartbeatAction {
  Start = 'start',
  Continue = 'continue',
  End = 'end'
}

// 获取用户卡片数据
export interface IUserCardRequest {
  room_id: number; // 房间id
  mid: number; // 用户id
  source: number; // 点击来源：1.普通弹幕 2.礼物弹幕
}

export enum IAttentionState {
  unfollow = 0,
  followed = 1,
  streamer = 2,
}

export enum IUserCardMoreAuth {
  mute = 1, // 禁言
  unmute = 2, // 解除禁言
  promote = 3, // 任命管理员
  deomote = 4, // 解除管理员
}
export interface IUserCardData {
  more: IUserCardMoreAuth[]; // 1.禁言 2.解除禁言
  name: string; // 用户名	
  avatar: string; // 头像	
  rank: number; // 排名
  attention: IAttentionState; // 0.未关注 1.已关注 2.主态		
  follower_num: number; // 关注人数
  arc_num: number // 稿件数
}
export interface IUserCardResponse extends IResponse {
  data: IUserCardData;
}

// 设置房间禁言状态
export enum IUserMuteState {
  unmute = 0, // 解除禁言
  mute = 1, // 禁言
}

export interface ISetUserMuteStateRequest {
  room_id: number; // 房间id
  mid: number; // 用户id
  state: IUserMuteState; // 点击来源：0.解除禁言 1.禁言
}

export enum IUserAdminState {
  normal = 0, // 解除房管
  admin = 1, // 提升为房管
}
export interface ISetUserAdminStateRequest {
  room_id: number; // 房间id
  mid: number; // 用户id
  state: IUserMuteState; // 点击来源：0.解除禁言 1.禁言
}

export interface ISetUserMuteStateResponse extends IResponse { }